export default __webpack_public_path__ + "33cb66ec7562af27b315652546842c55.svg";